export const SALES_HISTORY_FILTERS = [
    {label: 'SUCCEEDED', value: 'SUCCEEDED'},
    {label: 'FAILED', value: 'FAILED'},
]